import React from "react";
import MapIcon from "../../media/map.svg";
import MailIcon from "../../media/mail.svg";

function Contact() {
  console.log("mode is " + process.env.NODE_ENV);
  return (
    <>
      <section id="contact" className="contact">
        <div className="container">
          <div className="contact__content">
            <div className="contact__title">
              <p>contact</p>
              <h3>Don't be shy! Hit me up! 👇</h3>
            </div>
            <div className="contact__icons">
              <div className="contact__icon-box">
                <span>
                  <img src={MapIcon} alt="program_img" />
                </span>
                <div className="contact__info">
                  <h3>Location</h3>
                  <p>India</p>
                </div>
              </div>

              <div className="contact__icon-box">
                <span>
                  <img src={MailIcon} alt="program_img" />
                </span>
                <div className="contact__info">
                  <h3>Mail</h3>
                  <a href="mailto:j.purohit198@gmail.com">
                    j.purohit198@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
